// Machine-readable reason a manual provider swap was blocked. Returned as `blockedReason` by
// validateProviderSwapForActiveCampaigns and as `code` in the providers-change-for-type 400/
// validateOnly response bodies — the values are the wire format, so renaming one is a breaking
// API change.
export enum ProviderSwapValidationCodeEnum {
  // The new LOCAL provider has no available (PAIRED, active) numbers in one or more of the
  // preferred area codes required by the client's active campaigns of the requested campaign
  // type. Confirmable: a caller may proceed anyway via overrideAreaCodeWarning (MES-2587).
  NO_AREA_CODE_COVERAGE = 'NO_AREA_CODE_COVERAGE',
  // The requested providerId could not be resolved to a provider row (unknown/invalid/deleted).
  // Fail-closed (MES-2288): never overridable.
  PROVIDER_NOT_FOUND = 'PROVIDER_NOT_FOUND',
}
